import { useEffect, useState } from 'react';
import { Spinner } from '../Spinner';
import { Typography } from '../Typography';
import { ToastBoxWrapper, ToastOverlay, ToastRoot, ToastTextWrapper } from './Toast.styled';
import type { ToastProps } from './Toast.types';
import { toastStore } from './toastStore';

const toastDefaultValue = {
  position: 'center',
  variant: 'box',
  autoClose: 1500,
} as const;

export const Toast = (props: ToastProps) => {
  const { position, styledComponents, variant, icon, text, spinner, id, autoClose, button } = {
    ...toastDefaultValue,
    ...props,
  };

  const [isRemove, setIsRemove] = useState(false);

  const removeToast = () => {
    toastStore.remove(id);
  };

  useEffect(() => {
    if (!autoClose) return;

    const timeOut = autoClose ? toastDefaultValue.autoClose : autoClose;

    if (autoClose === true || typeof autoClose === 'number') {
      const timeId = setTimeout(() => {
        setIsRemove(true);
      }, timeOut);

      return () => {
        clearTimeout(timeId);
      };
    }

    return () => {};
  }, []);

  return (
    <ToastOverlay position={position}>
      <ToastRoot
        className={isRemove ? 'remove' : ''}
        onTransitionEnd={() => {
          removeToast();
        }}
        toastPosition={position}
        {...styledComponents?.root}
      >
        {variant === 'box' && (
          <ToastBoxWrapper {...styledComponents?.wrapper}>
            {spinner && (
              <Spinner
                color='blue.50'
                size='2XL'
                variant={spinner}
                {...styledComponents?.spinner}
              />
            )}
            {icon && icon}
            {text && typeof text === 'string' ? (
              <Typography color='system.white' fontType='body2.regular'>
                {text}
              </Typography>
            ) : (
              text
            )}
          </ToastBoxWrapper>
        )}
        {variant === 'text' && (
          <ToastTextWrapper
            alignItems='center'
            py={icon || spinner ? 12 : 16}
            {...styledComponents?.wrapper}
          >
            {icon && icon}
            {spinner && (
              <Spinner color='blue.50' size='XS' variant={spinner} {...styledComponents?.spinner} />
            )}
            {text && typeof text === 'string' ? (
              <Typography color='system.white' fontType='caption.regular'>
                {text}
              </Typography>
            ) : (
              text
            )}
            {button && button}
          </ToastTextWrapper>
        )}
      </ToastRoot>
    </ToastOverlay>
  );
};
